module.exports = __webpack_public_path__ + "static/media/home-comp-logos-msc.56af88a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-comp-logos-msc.png
// module id = 276
// module chunks = 0